<lib-country-list-standalone
    [allowedCountryCodes]="allCountryCodes"
    [selectedCountryCode]="code()"
    [countryListConfig]="{hideName: true}"
    [selectedCountryConfig]="{hideName: true}"
    (onCountryChange)="handleChange($event)" [ngClass]="{'disabled': disabled()}"
    placeholderText="Seleccionar país"
    >
</lib-country-list-standalone>